import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { OrderOP } from '@/types/types'
import useI18nTl from '@/hooks/useI18nTl'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'ShowEnumOrderOP',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  state: {
    type: Number,
  },
},
  setup(__props) {

const props = __props

const { t, tl } = useI18nTl('Evses')



const statusLabel = computed(() => {
  switch (props.state) {
    case OrderOP.OP_CHARGER_WALLET_PAY: // 充值单
      return t('Base.recharge')
    case OrderOP.OP_REFUND_WALLET_PAY: // 退款单
      return t('Base.refund')
    case OrderOP.OP_CHARGING: // 充电订单
      return t('Base.consumption')
    case OrderOP.OP_OCCUPANCY_PAY: // 占桩订单
      return t('Base.consumption')
  }
  return t('Base.unknown')
})

const tagLabel = computed(() => {
  switch (props.state) {
    case OrderOP.OP_CHARGER_WALLET_PAY: // 充值单
      break
    case OrderOP.OP_REFUND_WALLET_PAY: // 退款单
      break
    case OrderOP.OP_CHARGING: // 充电订单
      return t('Base.chargingOrder')
    case OrderOP.OP_OCCUPANCY_PAY: // 占桩订单
      return t('Base.occupancyOrder')
  }
  return ''
})

const color = computed(() => {
  return '#5e4eff'
})

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock("span", {
    class: "text-status",
    style: _normalizeStyle({ color: _unref(color) })
  }, [
    _createTextVNode(_toDisplayString(_unref(statusLabel)) + " ", 1),
    (_unref(tagLabel) != '')
      ? (_openBlock(), _createBlock(_component_el_tag, {
          key: 0,
          class: "mr10",
          type: "primary",
          effect: "plain",
          size: "small",
          hit: false,
          round: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(tagLabel)), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 4))
}
}

})